import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  supportedLangs = ['en', 'it', 'ar'];
  defaultLang = 'it';

  getBrowserLang(): string {
    const lang = navigator.language.split('-')[0].toUpperCase();
    return this.supportedLangs.includes(lang) ? lang : this.defaultLang;
  }

  getStoredLang(): string | null {
    return localStorage.getItem('Language');
  }

  setLang(lang: string) {
    localStorage.setItem('Language', lang);
  }

  resolveLang(): string {
    const stored = this.getStoredLang()?.toLowerCase();
    if (stored && this.supportedLangs.includes(stored)) {
      return stored;
    }
    const browser = this.getBrowserLang().toLowerCase();
    return this.supportedLangs.includes(browser) ? browser : this.defaultLang;
  }

  /**
   * Removes a leading `/<lang>/` segment from a URL path if present.
   * Useful when comparing `router.url` against hardcoded paths, since the URL
   * serializer always injects the active language into the visible URL.
   *
   * stripLang('/en/dashboard/hotels') -> '/dashboard/hotels'
   * stripLang('/dashboard')           -> '/dashboard'
   * stripLang('/ar')                  -> '/'
   */
  stripLang(url: string): string {
    if (!url) return url;
    const queryIdx = url.search(/[?#]/);
    const path = queryIdx >= 0 ? url.slice(0, queryIdx) : url;
    const tail = queryIdx >= 0 ? url.slice(queryIdx) : '';

    const segments = path.split('/').filter(Boolean);
    if (
      segments.length &&
      this.supportedLangs.includes(segments[0].toLowerCase())
    ) {
      const rest = segments.slice(1).join('/');
      return (rest ? '/' + rest : '/') + tail;
    }
    return url;
  }
}
